export default __webpack_public_path__ + "static/media/remove.a20e8fbf.svg";